export const COST_CATEGORY = "cost-category";

const costCategoryModel = {
  name: "",
  displayName: ""
};

export default costCategoryModel;
